const FETCH_AVAILABILITY_REQUEST = 'FETCH_AVAILABILITY_REQUEST'
const FETCH_AVAILABILITY_SUCCESS = 'FETCH_AVAILABILITY_SUCCESS'
const FETCH_AVAILABILITY_FAILURE = 'FETCH_AVAILABILITY_FAILURE'

export { FETCH_AVAILABILITY_REQUEST, FETCH_AVAILABILITY_SUCCESS, FETCH_AVAILABILITY_FAILURE }
